import React from 'react';
import PropTypes from 'prop-types';

const AdvInputWrapper = ({
  children,
  hasCurrency,
  hasPercentage,
  hasPerMonth,
  hasPerYear,
  hasPerDay,
  hasYear,
  hasValidation,
  isValid,
  validationMessage,
  className,
}) => (
  <div
    className={`custom-input
            ${className}
            ${hasCurrency && 'currency'}
            ${hasPercentage && 'percentage'}
            ${hasPerYear && 'has-per-year'}
            ${hasPerMonth && 'has-per-month'}
            ${hasPerDay && 'has-per-day'}
            ${hasYear && 'has-year'}
            ${hasValidation && 'with-validation'}
            ${!isValid && 'invalid'}`}
  >
    {children}

    {hasValidation && !isValid && <p>{validationMessage}</p>}
  </div>
);

AdvInputWrapper.defaultProps = {
  hasCurrency: false,
  hasPercentage: false,
  hasPerMonth: false,
  hasPerYear: false,
  hasPerDay: false,
  hasYear: false,
  hasValidation: false,
  isValid: true,
  validationMessage: '',
  className: '',
};

AdvInputWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  hasCurrency: PropTypes.bool,
  hasPercentage: PropTypes.bool,
  hasPerMonth: PropTypes.bool,
  hasPerDay: PropTypes.bool,
  hasPerYear: PropTypes.bool,
  hasYear: PropTypes.bool,
  hasValidation: PropTypes.bool,
  isValid: PropTypes.bool,
  validationMessage: PropTypes.string,
};

export default AdvInputWrapper;
